'use client'

import { useEffect, useState } from 'react'
import { globalErrorCopy, globalErrorLocale } from '@/lib/i18n/global-error-copy'

export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string }
  reset: () => void
}) {
  useEffect(() => {
    console.error('Global error:', error)
  }, [error])

  // 916-д9: провайдера переводов здесь нет — язык по тому же выбору человека.
  const [copy] = useState(() => globalErrorCopy(
    typeof document === 'undefined' ? 'ru' : globalErrorLocale(document.cookie, navigator.languages ?? []),
  ))

  return (
    <html>
      <body style={{ fontFamily: 'system-ui, -apple-system, sans-serif', padding: 0, margin: 0 }}>
        <div style={{
          minHeight: '100vh',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          background: '#F1F2F8',
        }}>
          <div style={{
            maxWidth: 480,
            background: 'white',
            borderRadius: 12,
            padding: 32,
            textAlign: 'center',
            boxShadow: '0 1px 3px rgba(0,0,0,0.05)',
          }}>
            <div style={{
              width: 64, height: 64, borderRadius: '50%',
              background: '#FEE2E2', color: '#DC2626',
              display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
              fontSize: 28, fontWeight: 'bold',
            }}>!</div>
            <h1 style={{ marginTop: 16, fontSize: 20, fontWeight: 700, color: '#111827' }}>
              {copy.title}
            </h1>
            <p style={{ marginTop: 8, fontSize: 14, color: '#6B7280' }}>
              {copy.hint}
            </p>
            {error.digest && (
              <p style={{ marginTop: 8, fontSize: 12, color: '#9CA3AF', fontFamily: 'monospace' }}>
                {copy.code} {error.digest}
              </p>
            )}
            <button
              onClick={reset}
              style={{
                marginTop: 24, padding: '10px 20px',
                background: '#6366F1', color: 'white',
                border: 'none', borderRadius: 8, fontSize: 14, fontWeight: 500,
                cursor: 'pointer',
              }}
            >
              {copy.retry}
            </button>
          </div>
        </div>
      </body>
    </html>
  )
}
